<template lang="pug">
.k-alert-blog
  v-slide-y-transition
    template(v-if="blogAlertOpen")
      div(:key="blogAlertOpen ? 'open' : 'closed'").brand-dark-blue--text.yellow-2
        k-container.py-10.text-center
          .relative
            .pr-10
              slot
            a(href="#" @click.prevent="close").k-alert-blog__close
              k-icon(color="brand-dark-blue" size="18") close
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
  computed: {
    ...sync({
      blogAlertOpen: 'guest/blogAlertOpen',
    })
  },
  mounted () {
    if (this.$route.path === '/articles') {
      this.blogAlertOpen = false
    }
  },
  methods: {
    close () {
      this.blogAlertOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.k-alert-blog {
  font-family: Beatrice;
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 25px;
  letter-spacing: -.5px;

  &__close {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
